import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
export const useUniqueId = (id) => {
    return useMemo(() => id || uuidv4(), [id]);
};
